export * from './shelf-and-bin-view.component';